import { useMutation } from '@tanstack/react-query';

import UsersService, { PatchUserPayload, UserCustomClaims } from '~/services/UsersService';

type PatchUserCustomClaimsPayload = Pick<PatchUserPayload, 'custom_claims'>;

export function usePatchUserCustomClaims(userId: string) {
  return useMutation({
    mutationFn: (customClaims: UserCustomClaims) => {
      const payload: PatchUserCustomClaimsPayload = { custom_claims: customClaims };
      return UsersService.patchUser(userId, payload);
    },
  });
}
